import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";

function mountRegistrationWidget(dom) {
  const root = ReactDOM.createRoot(dom);
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

(
  function (window) {
    if (typeof window?.mountRegistrationWidget === 'undefined') {
      window.mountRegistrationWidget = mountRegistrationWidget
    }
  }
)(window)

if (typeof window?.ReactNativeWebView === "undefined") {
  if (mountRegistrationWidget) mountRegistrationWidget(document.getElementById('root'));
}